import request from '../../../shared/request'

export function getJobSiteJobMinutes(job_id) {
  return request(`/job/job_site_job_minutes/${job_id}/`)
}

export function createJobMinute(payload) {
  return request(`/job/job_site_job_minutes/${payload.job_minute_data.job_id}/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function updateJobMinute(payload) {
  return request(`/job/job_site_job_minutes/${payload.job_minute_id}/`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteJobMinute(payload) {
  return request(`/job/job_site_job_minutes/${payload.job_minute_id}/`, {
    method: 'DELETE',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function uploadAttachments(payload) {
  return request(`/job/job_site_job_minutes/${payload.jobMinuteId}/attachment`, {
    method: 'POST',
    body: payload.formData,
    headers: {
      'content-type': 'multipart/form-data'
    }
  })
}

export function getAttachments(jobMinuteId) {
  return request(`/job/job_site_job_minutes/${jobMinuteId}/attachments/`)
}

export function updateAttachmentDescription(payload) {
  return request(`/job/job_site_job_minutes/${payload.attachmentId}/attachment`, {
    method: 'PUT',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteAttachment(payload) {
  return request(`/job/job_site_job_minutes/${payload.attachmentId}/attachment/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/job/jobSiteJobMinutes.js